import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanToYesNo',
  standalone: false,
})
export class BooleanPipe implements PipeTransform {
  transform(value?: boolean): string {
    if (value == null) return '-';

    return value ? 'Sim' : 'Não';
  }
}
